export const EMAIL = "vicksemmanuel58@gmail.com";
export const GITHUB = "https://github.com/vicksEmmanuel";
export const LINKEDIN = "https://www.linkedin.com/in/victor-u-04708316a/";
export const PHONE = "+44 7900 087608";
export const TWITTER = "";
export const SKILLS = [
  "Web Development",
  "Android & IOS Apps Development",
  "UI/UX",
  "Backend Development",
  "Artificial Intelligence",
  "Machine Learning",
];

export const TechSkills = [
  "React-Native",
  "React",
  "Swift",
  "Python",
  "ARKit",
  "Firebase",
  "GraphQL",
  "SQL",
  "Docker",
  "NodeJS",
  "C# & .Net Core",
  "NextJS",
  "Golang",
  "Flutter",
  "GCP",
  "RAG",
  "Gaussian Splatting",
  "and More...",
];

export const NameText = "Hi there 👋🏼, my name is";
export const CareerText = "I am a";
export const HeroText =
  "With over 7 years of software development experience, I have built a wide range of products across web, mobile, and desktop platforms. " +
  "I hold a Master's degree in Artificial Intelligence from Teesside University, UK, where I specialized in Reinforcement Learning, Machine Learning, RAG, and Deep Learning. " +
  "I am also a published researcher, with my work featured in IEEE Xplore: https://ieeexplore.ieee.org/document/10911886. " +
  "I am self-motivated, constantly learning, and dedicated to delivering excellence with a unique problem-solving perspective. Thank you.";
export const AnimationTime = 2;
export const RESEARCH_PAPER = "https://ieeexplore.ieee.org/document/10911886";
export const MASTERS_UNIVERSITY = "https://www.tees.ac.uk/";
